import FastPrint from "./FastPrint";

export default FastPrint;
